import React, {Component} from 'react';
import {withRouter} from "react-router";
import {Trans, translate} from 'react-i18next';
import listEn from '../../i18n/locales/en/faq.json'
import listRu from '../../i18n/locales/ru/faq.json'
import listDe from '../../i18n/locales/de/faq.json'
import listFr from '../../i18n/locales/fr/faq.json'
import listEs from '../../i18n/locales/es/faq.json'

import {Link} from "react-router-dom";

import '../../css/faq.scss';

class Faq extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            block: 0
        }
    }

    changeBlock(item) {
        if (item === this.state.block) {
            item = 0;
        }
        this.setState({
            block: item
        })
    }

    render() {
        const {t, i18n} = this.props;
        let list = listEn;
        // eslint-disable-next-line default-case
        switch (i18n.language) {
            case "ru":
                list = listRu.list;
                break;
            case "en":
                list = listEn.list
                break;
            case "de":
                list = listDe.list;
                break;
            case "fr":
                list = listFr.list;
                break;
            case "es":
                list = listEs.list;
                break;
        }
        let faq = [];

        for (let i = 0; i < list.length; i++) {
            if (list[i].group_name === this.props.faq_page) {
                faq = list[i].items.slice(0, 4)
            }
        }

        return (
            <div className={'faq-bar faq-container'}>
                <div className={'center'}>
                    <div className={'max-width vertical-padding width'}>
                        <div className={'max-width-500 align-left'}>
                            <h2>{t('faq.title')}</h2>
                            {/*{t('faq.text')}*/}
                            <div className={'h-text2-last'}>
                                <Trans i18nKey="faq.text">On the <Link to={'/'+i18n.language+'/faq'} className={'url'}>FAQ</Link> page you will find all the answers to common
                                    questions asked about our services.</Trans>
                            </div>
                            {/*<div className={'read-more'} onClick={''}>{t('faq.read-more')}</div>*/}
                            {/*<br/>*/}
                        </div>
                        <div className={'left-right-container stretch mobile-column-reverse'}>
                            <div className={'left flex'}>
                                {faq.map((item, i) => (
                                        <div className={'item'} key={i} onClick={() => this.changeBlock(item)}>
                                            {item.q}
                                            {this.state.block === item && (
                                                <div className={'answer'}>
                                                    {
                                                        item.a.split("\n").map(function (item, idx) {
                                                            return (
                                                                <span key={idx}>
                                                                    {item}
                                                                    <br/>
                                                                </span>
                                                            )
                                                        })
                                                    }
                                                </div>
                                            )}
                                        </div>
                                    )
                                )}
                            </div>
                            <div className={'image-container '}>
                                <div className={'faq-img '}/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default withRouter(translate('home')(Faq));
